module.exports = __webpack_public_path__ + "static/media/result-footer.c63d83f2.png";